const log = (error) => {
  console.error(error)
}

const start = () => {
  return
}

export default { log, start }
